import styled, { css } from 'styled-components';
import Image from '../../../../image';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_GRID_AREAS, NAVIGATION_LOGO_SIZES, NAVIGATION_VIEWPORT_BREAKPOINTS, } from '../../../constants';
export const navigationLogoContainerStyles = ({ theme, $visible, }) => css `
	${!$visible &&
    css `
		display: none;
	`}
	margin-right: auto;
	grid-area: ${NAVIGATION_GRID_AREAS.LEFT};
	align-self: center;

	/* Don't visually show the link text, but have it there for SR */
	font-size: 0;

	&:focus-visible {
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		outline-offset: -${theme.borderWidth.m}px;
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		padding-left: ${pxToRem(theme.spacing['400'])};
		padding-right: ${pxToRem(theme.spacing['100'])};
	}
`;
export const NavigationLogoContainer = styled.a `
	${navigationLogoContainerStyles}
`;
/**
 * Navigation logo image
 */
export const navigationLogoImageStyles = () => css `
	width: auto;
	height: ${pxToRem(NAVIGATION_LOGO_SIZES.sm)};
	margin: 0;

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		height: ${pxToRem(NAVIGATION_LOGO_SIZES.lg)};
	}
`;
export const NavigationLogoImage = styled(Image) `
	${navigationLogoImageStyles}
`;
